<template>
    <div error-page>
        <p>Here Is Error Page!</p>
        <button @click="goHome">back home</button>
    </div>
</template>

<script>
export default {
    name: "ErrorPage",
    methods: {
        goHome() {
            this.$router.push("/");
        },
    },
};
</script>
